import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/Service/data.service';
import { OtherService } from 'src/app/Service/other.service';
import { FormGroup, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
declare let $: any;


@Component({

  selector: 'app-detail-service',

  templateUrl: './detail-service.component.html',

  styleUrls: ['./detail-service.component.css']

})

export class DetailServiceComponent implements OnInit {

  list_Car: any = [];

  list_Route: any = [];

  lst_Report: any = [];

  lst_Search: any = [];

  lst_Passenger: any = [];

  lst_Search_2: any = [];

  bViewMode: boolean = false;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    strUnitID: new FormControl('-1'),

    iRoute: new FormControl('-1'),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private _route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private dataService: DataService,

  ) { }

  ngOnInit(): void {

    this._route.params.subscribe((params: any) => {

      if (params?.id) {

        this.bViewMode = true;

        this.openViewModal({ strUnitID: params.id, strDate: `${params.y}/${params.m}/${params.d}` })

      }

    })

    //? دریافت لیست خودروها بدون تصویر

    if (!this.dataService.carList_New) {

      this.dataService.getCarList_New().then((resp: any) => {

        this.list_Car = this.dataService.carList_New;

      });

    }

    else {

      this.list_Car = this.dataService.carList_New;

    }

    //? دریافت مسیر

    this.get_Route();

  }

  get_Route = async () => {

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    };

    this._otherService.Showspinner();

    const resp = await axios.post(`Route_List`, model);

    this._otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.list_Route = res;

  }

  search_Report = async () => {

    if (this.mdl_Search.invalid) return this._tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    this._otherService.Showspinner();

    let model = this._otherService.stringNumberToNumber(this.mdl_Search.value);

    const resp = await axios.post(`Route_FunctionReport_Passenger_Temp_Report`, model);

    this._otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.lst_Report = res;

    this.lst_Search = res;

  }

  openViewModal = async (item: any) => {

    if (!this.bViewMode) {

      return window.open(`personnel/detail-service/${item.strUnitID}/${item.strDate}`);

    }

    else {

      this._otherService.Showspinner();

      let model = this._otherService.stringNumberToNumber({

        ...this.mdl_Search.value,

        strUnitID: item.strUnitID,

        strDate: item.strDate,

      });

      const resp = await axios.post(`Route_FunctionReport_Passenger_Temp_Boarded`, model);

      this._otherService.nonespinner();

      let res = JSON.parse(resp.data);

      if (res.bError) return this._tooltip.showError(res.strError)

      this.lst_Passenger = res;

      this.lst_Search_2 = res;

      $("#viewModal").modal('show');
    }

  }

  showRoute(item: any) {

    window.open(`route/${item.strUnitID}`, '_blank')

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(item.strDtae));

    window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strTime));

    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(item.strETime));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(item.strUnitID.toString()));

    window.localStorage.setItem("carName", this.gurdService.encrypt(item.strFullName.toString()));

    window.localStorage.setItem("plate", this.gurdService.encrypt(item.strVehicleNo.toString()));

  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el.strFullName.includes(val.value) ||

        el.strMobileType_strComment.includes(val.value)


    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }

  }

  filter_Passenger(val: any) {

    this.lst_Passenger = this.lst_Search_2.filter((el: any) => {

      return el.strName.includes(val.value) ||

        el.strMobileDomain_strComment.includes(val.value) ||

        el.strUserManager_Chart_strComment.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Passenger = this.lst_Search_2;

    }

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'گزارش جزئیات پرسنل در سرویس.xlsx');
  }


}
